import { render, staticRenderFns } from "./SEOSection.vue?vue&type=template&id=04a9e116&scoped=true"
import script from "./SEOSection.vue?vue&type=script&lang=js"
export * from "./SEOSection.vue?vue&type=script&lang=js"
import style0 from "./SEOSection.vue?vue&type=style&index=0&id=04a9e116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a9e116",
  null
  
)

export default component.exports